export default __webpack_public_path__ + "static/media/insta.b5d73264.svg";